import { IconButton } from 'Components/Button';
import { Button, Col, Form } from 'react-bootstrap';
import { ICONS } from 'Utils/icons';

function SearchInput({ 
    itemLocation, 
    setIsFocusBase, 
    setShowFloatingDropdown, 
    setSearchTerm, 
    searchTerm,  
    getSearchData, 
    isSticky, 
    setSearchBarFocus,
    setSearchBtnFocus,
    searchBar,
    searchBtn,
    subOnly,
    exitSearch
}) {

    const handleFocusLocation = () => {
        if(itemLocation=='fixed'){
            setIsFocusBase(false);
        }
        else{
            setIsFocusBase(true);
        }
    }

    return (
        <Form 
            onSubmit={(e)=>{
                e.preventDefault();
            }}
            className={"flex-grow-1 search-form " + (itemLocation=='fixed' ? "p-2" : "p-0")}  
            role="search" 
            aria-label="Search Data Elements"
        >
            <div id="" className="g-0 d-flex flex-row flex-nowrap flex-md-nowrap flex-md-row gap-0">
                <Col className="d-flex flex-column flex-lg-row  g-0 position-relative gap-4 ">
                    <Form.Group className="d-flex flex-row align-items-center g-0 lh-1 flex-shrink-1 flex-grow-1">
                        <div className="w-100 position-relative">
                            <Form.Control
                                id="repoSearchBar"
                                key={"searchBar"}
                                ref={searchBar} 
                                value={searchTerm} 
                                onChange={(e)=>{
                                    var val = e.target.value;
                                    setSearchTerm(val);
                                }} 
                                onKeyDown={(e)=>{
                                    if(e.code==="Enter"){
                                        e.preventDefault();
                                        if(searchTerm!=null && searchTerm.trim()!=""){
                                            getSearchData(searchTerm, subOnly);
                                            setSearchBarFocus(true);
                                            setShowFloatingDropdown(true);       
                                        }
                                    }
                                }}
                                onFocus={(e) => {
                                    handleFocusLocation();
                                    setSearchBarFocus(true)
                                }}
                                onBlur={(e) => {
                                    setSearchBarFocus(false);
                                }}
                                className={isSticky==true ? "m-0  sticky-indicator body":"m-0 body"}
                                role="searchbox" 
                                aria-label="Search data elements by ID, name, and/or description."
                                placeholder="Search data elements by ID, name, and/or description."
                            >
                            </Form.Control>
                            {
                                searchTerm!=null && searchTerm.trim()!=""
                                ?   <Button 
                                        title="Exit Search"
                                        key={"clearTextBtn"}
                                        variant="comp-plain" 
                                        id="repoSearchBarClearBtn"
                                        hiddenText="Exit Search"
                                        className="d-flex mt-sm-0  mb-0 justify-content-center align-items-center body semibold position-absolute" 
                                        onClick={()=>{
                                            exitSearch();
                                        }}
                                    >
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill="#686E7A"/>
                                        </svg>
                                    </Button>
                                :   null
                            }
                        </div>
                        <IconButton 
                            title="Search data elements by ID, name, and/or description."
                            key={"searchBtn"}
                            ref={searchBtn} 
                            variant="comp-secondary" 
                            content={'Search'} 
                            id="repoSearchBarBtn"
                            hiddenText="Search"
                            className="d-flex mt-sm-0  mb-0 justify-content-center align-items-center body semibold h-100" 
                            onClick={()=>{
                                if(searchTerm!=null && searchTerm.trim()!=""){
                                    getSearchData(searchTerm, subOnly);
                                    handleFocusLocation();
                                    setSearchBtnFocus(true);
                                    setShowFloatingDropdown(true);    
                                }
                            }}
                            icon={ICONS.search()}
                            onFocus={(e) => {
                                handleFocusLocation();
                                setSearchBtnFocus(true);
                            }}
                            onBlur={(e) => {
                                setSearchBtnFocus(false);
                            }}
                        />
                    </Form.Group>
                </Col>
            </div>
        </Form>
    );
}

export default SearchInput;